import { getFlow, setFlow } from '../../passwordless-login/services/FlowService';
import { getWindow } from '../../window/Window';
import { ROUTES } from '../../Routes';

enum FlowType {
  register = 'register',
  resetPassword = 'reset-password',
  callCenterRegister = 'call-centre-register',
  callCenterResetPassword = 'call-centre-reset-password',
  login = 'login',
  iFrameLogin = 'iframe-login',
  manualReg = 'manual-reg',
  cookie = 'cookie',
  forgotUsername = 'forgot-username',
}

const setPasswordRoutes = {
  [FlowType.callCenterRegister]: ROUTES.CALL_CENTRE_REGISTER_SET_YOUR_PASSWORD,
  [FlowType.callCenterResetPassword]: ROUTES.CALL_CENTRE_RESET_PASSWORD_SET_YOUR_PASSWORD,
  [FlowType.register]: ROUTES.REGISTER_SET_YOUR_PASSWORD,
  [FlowType.resetPassword]: ROUTES.RESET_PASSWORD_SET_YOUR_PASSWORD,
  [FlowType.manualReg]: ROUTES.MANUAL_REG_SET_YOUR_PASSWORD,
  [FlowType.forgotUsername]: ROUTES.FORGOT_USERNAME_FIND_CUSTOMER,
};

const getSetPasswordRoute = (): string => {
  return setPasswordRoutes[getFlow()];
};

const initialiseFlowFromSetPasswordPage = () => {
  if (!getFlow()) {
    if (isPasswordlessLoginFlow()) {
      // if the flow does not correctly
      // get passed through for some reason during a
      // passwordless login flow default to reset password flow
      // This should fix the bug where forgot pw
      // flow sometimes incorrectly shows the thank you
      // page
      setFlow(FlowType.resetPassword);
    } else {
      setFlow(
        isCallCenterRegisterFlow() ? FlowType.callCenterRegister : FlowType.callCenterResetPassword,
      );
    }
  }
};

const isPasswordlessLoginFlow = (): boolean => {
  // if the state param exists, we know the user is coming from
  // the passwordless login flow
  const stateParam = new URLSearchParams(getWindow().location.search).get('state');
  return !!stateParam;
};

// if the user got an email from the call center to reset their password
// it should contain this url param
const isCallCenterRegisterFlow = (): boolean => {
  return getUserActionParam() === 'activate';
};

const getUserActionParam = () => {
  // The param looks like the following in the url:
  // It appears after the hash to we must retrieve it in a specific way
  // https://id.preprod.originenergy.com.au/lo/reset?ticket=blablabla#&useraction=activate
  const hash = getWindow().location.hash || '';
  return new URLSearchParams(hash.substring(1)).get('useraction');
};

export { getSetPasswordRoute, FlowType, initialiseFlowFromSetPasswordPage };
